import { IQuotePrice } from '@monetize/types/app';
import { useGetQuotePrices } from '../api/cpqService';

const defaultValue = [] as IQuotePrice[];

export interface QuotePricesDataTypes {
  loading: boolean;
  quotePrices: IQuotePrice[];
}
const useQuotePrices = (quoteId: string): QuotePricesDataTypes => {
  const { data: quotePricesData, isLoading: loading } = useGetQuotePrices(
    quoteId,
    { enabled: !!quoteId },
  );

  return {
    loading,
    quotePrices: quotePricesData || defaultValue,
  };
};

export default useQuotePrices;
